/*
 * Copyright (c) 2025 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { PackageVoModel } from '@well/delivery-libs/packages/domain';
import { JSONable } from '@irian-ro/abstract-resource';
import { ProofOfHandoverAttachmentDtoModel } from './proof-of-handover-attachment-dto.model';

export class ProofOfHandoverDTO extends JSONable{

  uuid: string | null = null;

  warehouseEmployeeName: string | null = null;

  selectedPackageVOs: PackageVoModel[] = [];

  attachments: ProofOfHandoverAttachmentDtoModel[] = [];

  status: string | null = null;

  achievedAt: string | null = null;

  comment: string | null = null;

}
